import OfflineBooksContainer from './OfflineBooksContainer';
export default OfflineBooksContainer;
